var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6098_49123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.33325C4.31333 1.33325 1.33333 4.31325 1.33333 7.99992C1.33333 11.6866 4.31333 14.6666 8 14.6666C11.6867 14.6666 14.6667 11.6866 14.6667 7.99992C14.6667 4.31325 11.6867 1.33325 8 1.33325ZM11.3333 10.3933L10.3933 11.3333L8 8.93992L5.60667 11.3333L4.66667 10.3933L7.06 7.99992L4.66667 5.60659L5.60667 4.66659L8 7.05992L10.3933 4.66659L11.3333 5.60659L8.94 7.99992L11.3333 10.3933Z",
    fill: "#878889"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6098_49123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.a5b6af4a5a9d884517146a5fe330f07f.svg";
export { ForwardRef as ReactComponent };